import { Box, keyframes, styled, Typography } from "@mui/material";


export let color1="rgb(255, 78, 35)";
export let color2="rgb(58, 177, 119)";
export let color3="rgb(48, 207, 255)";
export let color4="rgb(200, 36, 254)";


export let color1Shade="rgb(255, 221, 214)";
export let color2Shade="rgb(228, 255, 242)";
export let color3Shade="rgb(225, 248, 255)";
export let color4Shade="rgb(245, 217, 254)";





const bar=(value)=>keyframes`
from{
    width: 0px;
}
to{
width: ${value};
}
`
export const Bar=styled(Box)(({theme})=>(
    {
        width:"100%",
        height:"13px",
        backgroundColor:theme.palette.shade.light,
        borderRadius:"10px",
        overflow:"hidden"
    }
))

export const BarValue=styled(Box)(({ theme, value })=>(
    {
        width:`${value}%`,
        height:"100%",
        backgroundColor:theme.palette.primary.main,
        borderRadius:"10px",
        animation: `${bar(value)} 2s linear 0s 1`,
    }
))

export const SkillName=styled(Box)(({theme})=>(
    {
        display:"flex",
        justifyContent:"space-between",
        padding:"5px 10px",
        color:"text.primary",
    }
))
